import { render, staticRenderFns } from "./SymbolDetail.vue?vue&type=template&id=44bb9ae4&scoped=true"
import script from "./SymbolDetail.vue?vue&type=script&lang=js"
export * from "./SymbolDetail.vue?vue&type=script&lang=js"
import style0 from "./SymbolDetail.vue?vue&type=style&index=0&id=44bb9ae4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bb9ae4",
  null
  
)

export default component.exports